module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-zh-TW.72f9e63a.jpg";